module.exports = __webpack_public_path__ + "img/male.c1ff8f74.png";